import { apiClient } from '@/api'

export default {
  namespaced: true,
  state: () => ({
    abonements:[],
  }),
  mutations: {
    SET_ABONEMENTS(state, items) {
      state.abonements = items
    }
  },
  actions: {
    async getAbonements({ commit }, data) {
      const res = await apiClient('abonements.get', data)
      commit('SET_ABONEMENTS', res.list)
    },
    async addAbonement({ commit }, data) {
      const res = await apiClient('abonements.add', data)
      commit('SET_ABONEMENTS', res.list)
    },
    async activateAbonement({ commit }, data) {
      const res = await apiClient('abonements.activate', data)
      commit('SET_ABONEMENTS', res.list)
    },
    async deleteAbonement({ commit }, data) {
      const res = await apiClient('abonements.delete', data)
      commit('SET_ABONEMENTS', res.list)
    },
    async updateAbonement({ commit }, data) {
      const res = await apiClient('abonements.update', data)
      commit('SET_ABONEMENTS', res.list)
    }
  }
}